import { useRef, useEffect, useState } from "react";
import {Box} from "./Box";
import {spaceUnit} from "./styles";

type Props =
  | {
      /**
       * How many units to fill along the main axis
       */
      units: number;
      fluid?: never;
    }
  | {
      /**
       * Whether the space should "grow" and fill all the available space along the main axis
       */
      fluid: true;
      units?: never;
    };

export function Space(props: Props) {
  const spaceRef = useRef<HTMLDivElement>(null);
  const [parentDirection, setParentDirection] = useState<"column" | "row">(
    "row"
  );

  // NOTE(gabro): Setting basis should technically be enough, since basis acts like width/height
  // and it follows the primary flex dimension of the container.
  // However, there's a bug in Chrome (and potentially other browsers) which causes the parent to
  // ignore basis when computing the container size.
  // See https://bugs.chromium.org/p/chromium/issues/detail?id=464210 and
  // https://github.com/philipwalton/flexbugs/issues/223.
  // This is the reason why we manually inspect the container and set either width or height
  // depending on its flex direction (we still set basis, for completeness).
  useEffect(() => {
    if (spaceRef.current && spaceRef.current.parentElement) {
      if (spaceRef.current.parentElement.style.flexDirection === "column") {
        setParentDirection("column");
      } else {
        setParentDirection("row");
      }
    }
  }, []);

  function boxProps() {
    switch (parentDirection) {
      case "row":
        const width = props.units ? props.units * spaceUnit : undefined;
        return { width, basis: width };
      case "column":
        const height = props.units ? props.units * spaceUnit : undefined;
        return { height, basis: height };
    }
  }

  return (
    <Box
      ref={spaceRef}
      {...boxProps()}
      grow={props.fluid}
      shrink={props.fluid}
      style={{pointerEvents: "none"}}
    />
  );
}
